export default __webpack_public_path__ + "static/media/image3.3b553bce.png";